import "./PrimaryLabel.css"

export default function PrimaryLabel(props) {
    const extraClassName = (props.extraClassName || "").trim()
    const value = props.children

    let className = "block text-gray-700 text-sm font-primary mb-2"
    className = [className, extraClassName].join(" ")
    return (
        <label className={className}>
            {value}
        </label>
    )
}